module.exports = __webpack_public_path__ + "img/sam-kerr.bf415f98.png";